import { forEach, intersection, isNull, isUndefined, isObject } from 'lodash';

export const buildNewManualBank = ({
  manualBankAccountNumber,
  manualBankAccountType,
  manualBankJointOwnerFirstName,
  manualBankJointOwnerLastName,
  manualBankOwner,
  manualBankRoutingNumber,
}) => {
  const registrationLines = [];
  if (manualBankOwner) {
    registrationLines.push(manualBankOwner);
  }
  if (manualBankJointOwnerFirstName || manualBankJointOwnerLastName) {
    registrationLines.push({
      firstName: manualBankJointOwnerFirstName,
      lastName: manualBankJointOwnerLastName,
    });
  }
  return {
    bankAgreementID: Date.now(),
    accountNumber: manualBankAccountNumber,
    routingNumber: manualBankRoutingNumber,
    name: null,
    registrationLines,
    bankAccountType: manualBankAccountType,
    bankAwaitingVerification: true,
    new: true,
  };
};

export const isPlaidBank = (bank) => {
  if (isObject(bank)) {
    // bank object
    if (bank.externallyVerifiedBank) {
      return true;
    }
  }
  return false;
};

// checking whether the RegistrationTypes for the add new fund should be disabled or not according to the bankSelection
export const isRegistrationAssociatedWithModalId = (registration) => {
  return (
    registration &&
    registration.modelAgreementUniqueIDs &&
    registration.modelAgreementUniqueIDs.length !== 0
  );
};

export const isRegistrationAssociatedWithBank = (
  registration,
  selectedBankAssociableOrAssociatedLookup
) => {
  return (
    registration &&
    registration.modelAgreementUniqueIDs &&
    registration.modelAgreementUniqueIDs.some(
      (modelUID) => selectedBankAssociableOrAssociatedLookup[modelUID]
    )
  );
};

export const getLastFour = (acctNum) => {
  return acctNum.substring(acctNum.length - 4, acctNum.length);
};

/* *** VALIDATION ***** */
export const verifyName = (nameArray, firstName, lastName) => {
  // @param: Array - ["John C Doe", "Jane E Doe"]
  // @param: String - firstName
  // @param: String - lastName
  if (!firstName && !lastName) {
    return false;
  }
  return nameArray
    .map((n) => n.toUpperCase())
    .some(
      (name) =>
        name.includes(firstName.toUpperCase()) &&
        name.includes(lastName.toUpperCase())
    );
};

export const getStreetNumber = (addressLine) => {
  const STREET_REGEX = new RegExp(/[-_().,':;"#&/@\s]+/g);
  const STREET_NUM_REGEX = new RegExp(/^[\d\s]+/);
  const cleanStreet = addressLine.replace(STREET_REGEX, ' ');
  const streetNumber =
    !isNull(cleanStreet.match(STREET_NUM_REGEX)) &&
    !isUndefined(cleanStreet.match(STREET_NUM_REGEX)[0])
      ? cleanStreet.match(STREET_NUM_REGEX)[0]
      : '';
  return streetNumber;
};

//FYI: We are comparing state NASU is not
export const verifyAddress = (bankLine, bankZip, userLine, userZip) => {
  // @param: String line1 - "123 Canary Ln"
  // @param: int zip - 21224
  const userAddressLines = []; // different from other two because we need parse the lines before adding to array
  const bankAddressLines = [];
  const userZipcodes = [];
  const bankZipcodes = [];
  const userAddressNumbers = [];
  const bankAddressNumbers = [];

  if (!isUndefined(bankLine) && !isNull(bankLine)) {
    bankAddressLines.push(bankLine);
  }
  if (!isUndefined(bankZip) && !isNull(bankZip)) {
    const zip5 = bankZip.split('-')[0];
    bankZipcodes.push(zip5);
  }
  if (!isUndefined(userLine) && !isNull(userLine)) {
    userAddressLines.push(userLine);
  }
  if (!isUndefined(userZip) && !isNull(userZip)) {
    userZipcodes.push(userZip);
  }
  forEach(userAddressLines, (line) => {
    if (!isNull(line) && !isUndefined(line)) {
      userAddressNumbers.push(getStreetNumber(line));
    }
  });
  forEach(bankAddressLines, (line) => {
    if (!isNull(line) && !isUndefined(line)) {
      bankAddressNumbers.push(getStreetNumber(line));
    }
  });
  // if the address number and zipcode or state match we will pass them
  return (
    intersection(userAddressNumbers, bankAddressNumbers).length > 0 &&
    intersection(userZipcodes, bankZipcodes).length > 0
  );
};

/**
 * Returns if user has exceeded max limit of 3 times for add bank via everify and plaid
 *
 * @param path
 * @param everifyAttempts
 * @param plaidAttempts
 * @return {boolean}
 */
export const isLockout = (path, everifyAttempts, plaidAttempts) => {
  return (
    (path === 'MANUAL' && everifyAttempts >= 3) ||
    (path === 'LINK' && plaidAttempts >= 3)
  );
};
